import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { SectionLayout } from 'components/Sections/SectionLayout';
import RichText from 'components/RichText';

const EmbedCode = ({ code, headCode }) => (
  <SectionLayout>
    <EmbedCodeContainer>
      <RichText content={code} headCode={headCode} />
    </EmbedCodeContainer>
  </SectionLayout>
);

EmbedCode.propTypes = {
  code: PropTypes.string,
};

export default EmbedCode;

const EmbedCodeContainer = styled.div`
  display: flex;
  justify-content: center;

  span {
    display: contents;
  }
`;
